import { cloned } from '@/helpers'

const EMPTY_QUERY = {
  id: -1,

  master_id: -1, // El id desde cual se obtiene la lista de record_def a filtrar
  record_def_id: -1, 

  title: "",

  since: "2000-01-01 00:00:00", // parametro de fecha "desde" formato YYY-MM-DD HH:MM:SS
  
  to: "", //parametro de fecha "hasta" formato YYY-MM-DD HH:MM:SS
  
  state: "A", //parametro de filtro por estado, ver Record.STATES
  
  assigned: -1, //devuelve los registos donde sea el assigned
  
  creator: -1, //devuelve los registros donde sea el creador

  changer: -1, //devuelve los registros donde sea el changer

  limit: 100, //maximo de resultados devueltos

  start: 0, //el offset desde el cual comienzan los resultados

  // lista de columnas (props del registro) a devolver
  columns: [], // { property, label }

  // filtros a aplicar para ciertas columnas
  filters: [] // { property, label, condition, value}
}

export const Query = {

  empty() {
    return cloned(EMPTY_QUERY);
  }
}
